import { useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { HostLobby, LiveHostGame } from "../features/host/index.js";

export function HostLobbyPage() {
  const { sessionId } = useParams<{ sessionId: string }>();
  const [gameStarted, setGameStarted] = useState(false);

  if (!sessionId) return <Navigate to="/admin/quizzes" replace />;

  if (gameStarted) {
    return <LiveHostGame sessionId={sessionId} />;
  }

  return <HostLobby sessionId={sessionId} onGameStarted={() => setGameStarted(true)} />;
}
